/* Shared behaviour for snippets/drawer.liquid: opening, closing, the focus trap and
   the scroll lock. Every drawer section loads this file, so the whole thing is guarded
   — two script tags with the same src both execute, and binding the delegated handlers
   twice would close a drawer in the same click that opened it.

   Triggers are matched by delegation from the document rather than bound per element,
   so markup that arrives later (a section re-rendered over Ajax) needs no re-wiring. */
(function () {
  'use strict';

  if (window.themeDrawer) return;

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var openDrawer = null;
  var lastFocus = null;

  function panelOf(drawer) {
    return drawer.querySelector('.drawer__panel');
  }

  function focusables(drawer) {
    var panel = panelOf(drawer);
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
      /* offsetParent is null for anything display:none'd — a collapsed empty state, a
         hidden error line — which must not become a stop in the tab cycle. */
      return el.offsetParent !== null;
    });
  }

  function open(name) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer || drawer === openDrawer) return;
    if (openDrawer) close();

    lastFocus = document.activeElement;
    drawer.hidden = false;

    /* `hidden` is display:none, so the panel has no box to transition from until the
       browser has laid it out once. Two frames: one for layout, one for the class. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    });

    document.documentElement.classList.add('no-scroll');
    openDrawer = drawer;

    var target = drawer.querySelector('[data-drawer-autofocus]') || focusables(drawer)[0];
    if (target) target.focus();

    drawer.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  }

  function close() {
    var drawer = openDrawer;
    if (!drawer) return;

    openDrawer = null;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');

    /* Hiding it again waits for the slide out, but transitionend never fires under
       prefers-reduced-motion (there is no transition to end), so the timeout is the
       one that actually runs there. Both re-check the class in case it reopened. */
    var panel = panelOf(drawer);
    var settle = function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    };
    if (panel) panel.addEventListener('transitionend', settle, { once: true });
    setTimeout(settle, 400);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;

    drawer.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
  }

  function trapTab(event) {
    var list = focusables(openDrawer);
    if (!list.length) return;

    var first = list[0];
    var last = list[list.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-drawer-open]');
    if (trigger) {
      /* The trigger is a real link to the page this drawer stands in for, so the
         default has to be cancelled here rather than left off the markup. */
      event.preventDefault();
      open(trigger.dataset.drawerOpen);
      return;
    }

    if (openDrawer && event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openDrawer) return;
    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'Tab') {
      trapTab(event);
    }
  });

  window.themeDrawer = { open: open, close: close };
})();
